module.exports = __webpack_public_path__ + "6a2bb1b24bb07cf80753348312509791.jpg";